export default {"src":"/_next/static/media/influencers.e7b8861a.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};